module.exports = __webpack_public_path__ + "img/4.481977c4.png";